import React, { useState } from 'react';
// CORRECTED: 'Link' has been removed from this import statement
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/'); // Redirect to dashboard
    } catch (error) {
      console.error("Error logging in:", error);
      if (error.code === 'auth/user-disabled') {
        alert('Your account is awaiting administrator approval. Please check back later.');
      } else {
        alert(error.message);
      }
    }
  };

  return (
    <div>
      <h2>Login to COA Database</h2>
      <form onSubmit={handleLogin}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          required
        />
        <br />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter your password"
          required
        />
        <br />
        <button type="submit">Login</button>
      </form>
      {/* The registration link that used <Link> was removed, causing the error. */}
    </div>
  );
}

export default Login;